import {
  DynamicPriceQuizQuestions,
  DynamicPriceQuizResults,
  StackingCardsFlow,
  StackingResultCards
} from 'features/dynamic-tariff/components/quiz/types'
import { startSimulationOrRegistration } from 'utils/customerFlow'
import { calculateScoreForResult } from 'features/dynamic-tariff/utils'
import { PORTAL_URL } from 'constants/constants'
import { Language } from 'types/language'

export const ACTIVATE_IN_PORTAL_URL = `${PORTAL_URL}/addresses`

export const QUIZ_RESULT_CARDS: StackingResultCards<DynamicPriceQuizResults> = {
  [DynamicPriceQuizResults.UNAVAILABLE_FLANDERS_ONLY]: {
    actions: {
      primary: {
        internalRoute: 'pricing'
      }
    }
  },
  [DynamicPriceQuizResults.UNAVAILABLE_DIGITAL_METER_REQUIRED]: {
    actions: {
      primary: {
        externalUrl: (language) =>
          language === Language.FRENCH
            ? 'https://www.synergrid.be/fr/au-sujet-des-reseaux/le-grd-dans-votre-commune'
            : 'https://www.synergrid.be/nl/over-de-netten/dnb-in-uw-gemeente'
      }
    }
  },
  [DynamicPriceQuizResults.UNAVAILABLE_GENERAL]: {
    actions: {
      primary: {
        internalRoute: 'pricing'
      }
    }
  },
  [DynamicPriceQuizResults.INTERESTING]: {
    rating: { state: 'positive' },
    actions: {
      primary: {
        action: () => startSimulationOrRegistration()
      },
      secondary: {
        externalUrl: () => ACTIVATE_IN_PORTAL_URL
      }
    }
  },
  [DynamicPriceQuizResults.CONSIDERABLE]: {
    rating: { state: 'informative' },
    actions: {
      primary: {
        action: () => startSimulationOrRegistration()
      },
      secondary: {
        externalUrl: () => ACTIVATE_IN_PORTAL_URL
      }
    }
  },
  [DynamicPriceQuizResults.NOT_INTERESTING]: {
    rating: { state: 'negative' },
    actions: {
      primary: {
        action: () => startSimulationOrRegistration()
      },
      secondary: {
        externalUrl: () => ACTIVATE_IN_PORTAL_URL
      }
    }
  }
}

export const QUIZ_FLOW: StackingCardsFlow<DynamicPriceQuizQuestions, DynamicPriceQuizResults> = [
  {
    question: DynamicPriceQuizQuestions.LOCATION,
    actions: {
      yes: {
        next: () => DynamicPriceQuizQuestions.METER,
        icon: 'check',
        value: true
      },
      no: {
        next: () => DynamicPriceQuizResults.UNAVAILABLE_FLANDERS_ONLY,
        icon: 'cross',
        value: false
      }
    }
  },
  {
    question: DynamicPriceQuizQuestions.METER,
    actions: {
      yes: {
        next: () => DynamicPriceQuizQuestions.SOLAR_PANELS_OR_HOME_BATTERY,
        icon: 'check',
        value: true
      },
      no: {
        next: () => DynamicPriceQuizResults.UNAVAILABLE_DIGITAL_METER_REQUIRED,
        icon: 'cross',
        value: false
      }
    }
  },
  {
    question: DynamicPriceQuizQuestions.SOLAR_PANELS_OR_HOME_BATTERY,
    actions: {
      yes: {
        next: () => DynamicPriceQuizQuestions.ELECTRIC_VEHICLE,
        icon: 'check',
        value: true
      },
      no: {
        next: () => DynamicPriceQuizQuestions.ELECTRIC_VEHICLE,
        icon: 'cross',
        value: false
      }
    }
  },
  {
    question: DynamicPriceQuizQuestions.ELECTRIC_VEHICLE,
    actions: {
      yes: {
        next: () => DynamicPriceQuizQuestions.SMART_HOME,
        icon: 'check',
        value: true // Higher weight due to score result logic
      },
      no: {
        next: () => DynamicPriceQuizQuestions.SMART_HOME,
        icon: 'cross',
        value: false
      }
    }
  },
  {
    question: DynamicPriceQuizQuestions.SMART_HOME,
    actions: {
      yes: {
        next: calculateScoreForResult,
        icon: 'check',
        value: true
      },
      no: {
        next: calculateScoreForResult,
        icon: 'cross',
        value: false
      }
    }
  }
]
